import { MonitorSmartphone } from "lucide-react";

const LiveDisplayTileDesign = {
  id: "live-display",
  icon: MonitorSmartphone,
  label: "Live Display",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default LiveDisplayTileDesign;
